import React, {Component} from 'react';
import {IonBadge, IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel} from '@ionic/react';
import '../CalendarPage.css';
import CalendarItem from "../../domain/CalendarItem";
import DateUtils from "../../utils/Date.utils";
import {RouteComponentProps} from "react-router";
import StringUtils from "../../utils/String.utils";

type State = {}

type Props = RouteComponentProps<{}> & {
  item: CalendarItem;
}

export default class CalendarPageItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const {item} = this.props;
    return (
      <>
        <IonItemSliding key={item.id} class={"calendar-item"}>
          <IonItem class={"item"} button onClick={() => this.props.history.push(`/contests/${item.id}`)}>
            <IonBadge class="contest-date" slot="start">
              <h2>{StringUtils.pad(DateUtils.getDayOfMonth(item.date), 2)}</h2>
              <p>{DateUtils.getMonthAsString(item.date)}</p>
            </IonBadge>
            <IonLabel class="label">
              <h2 className="label-content">{item.title}</h2>
              <p className="label-content">{item.categories.join(" | ")}</p>
            </IonLabel>
          </IonItem>
        </IonItemSliding>
      </>
    );
  }
}
